/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HubCategory } from '../models/HubCategory'
import type { HubDocument } from '../models/HubDocument'
import type { HubFilters } from '../models/HubFilters'
import type { HubProduct } from '../models/HubProduct'
import type { HubRecommendedProduct } from '../models/HubRecommendedProduct'
import type { ResponseHubBasicProductsList } from '../models/ResponseHubBasicProductsList'
import type { ResponseHubProductsList } from '../models/ResponseHubProductsList'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class HubService {
  /**
   * Pobiera produkty po Id
   * @returns HubProduct Produkty z Huba Produktowego
   * @throws ApiError
   */
  public static getProducts({
    productsIds,
  }: {
    /**
     * identyfikatory produktów
     */
    productsIds?: Array<number>
  }): CancelablePromise<Array<HubProduct>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/hub/products',
      query: {
        productsIds: productsIds,
      },
    })
  }

  /**
   * Pobiera polecane produkty
   * @returns HubRecommendedProduct Polecane produkty z Huba Produktowego
   * @throws ApiError
   */
  public static getRecommendedProducts({
    limit,
  }: {
    /**
     * limit polecanych produktów do pobrania
     */
    limit: number
  }): CancelablePromise<Array<HubRecommendedProduct>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/hub/recommended-products',
      query: {
        limit: limit,
      },
    })
  }

  /**
   * Pobiera listę produktów po wybranych filtrach
   * @returns ResponseHubProductsList Produkty z Huba Produktowego
   * @throws ApiError
   */
  public static getProductsList({
    page,
    limit,
    category,
    subcategory,
    selfServeAds,
    labels,
    goals,
    tags,
    technicalCapabilities,
    emissionLocations,
    industries,
    emissionModels,
    benefits,
    formats,
    devices,
    name,
    isVisible,
  }: {
    /**
     * numer strony do pobrania
     */
    page: number
    /**
     * liczba elementów do pobrania
     */
    limit: number
    /**
     * kategoria
     */
    category?: number
    /**
     * podkategoria
     */
    subcategory?: number
    selfServeAds?: number
    labels?: Array<number>
    goals?: Array<number>
    tags?: Array<number>
    technicalCapabilities?: Array<number>
    emissionLocations?: Array<number>
    industries?: Array<number>
    emissionModels?: Array<number>
    benefits?: Array<number>
    formats?: Array<number>
    devices?: Array<number>
    /**
     * filtr po nazwie
     */
    name?: string
    /**
     * filtr po widocznosci
     */
    isVisible?: boolean
  }): CancelablePromise<ResponseHubProductsList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/hub/products-list',
      query: {
        category: category,
        subcategory: subcategory,
        selfServeAds: selfServeAds,
        labels: labels,
        goals: goals,
        tags: tags,
        technicalCapabilities: technicalCapabilities,
        emissionLocations: emissionLocations,
        industries: industries,
        emissionModels: emissionModels,
        benefits: benefits,
        formats: formats,
        devices: devices,
        name: name,
        isVisible: isVisible,
        page: page,
        limit: limit,
      },
    })
  }

  /**
   * Pobiera listę produktów z id i nazwą
   * @returns ResponseHubBasicProductsList Produkty z Huba Produktowego
   * @throws ApiError
   */
  public static getBasicProductsList(): CancelablePromise<ResponseHubBasicProductsList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/hub/basic-products-list',
    })
  }

  /**
   * Pobiera drzewko kategorii
   * @returns HubCategory Drzewko kategorii z Huba Produktowego
   * @throws ApiError
   */
  public static getCategories(): CancelablePromise<Array<HubCategory>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/hub/categories',
    })
  }

  /**
   * Pobiera listę filtrów
   * @returns HubFilters Filtry z Huba Produktowego
   * @throws ApiError
   */
  public static getFilters(): CancelablePromise<HubFilters> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/hub/filters',
    })
  }

  /**
   * Pobiera drzewko dokumentów
   * @returns HubDocument Drzewko dokumentów z Huba Produktowego
   * @throws ApiError
   */
  public static getDocuments(): CancelablePromise<Array<HubDocument>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/hub/documents',
    })
  }
}
